<template>
  <div id="app" :class="{'nav-open': $sidebar.showSidebar}">
    <LoginModal></LoginModal>
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <router-view name="header"></router-view>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
// @ is an alias to /src
// Loading some plugin css asynchronously
import 'sweetalert2/dist/sweetalert2.css'

import LoginModal from '@/components/Misc/LoginModal';

export default {
  name: 'App',
  components: {
    LoginModal
  },
}
</script>
<style lang="scss">

</style>
